<template>
  <div class="beauty" v-wechat-title="$route.meta.title">
    <div>
      <img id="logo" src="../assets/Beauty.jpg">
    </div>
    <div class="buttonrow">
      <button id="closewindowbutton" v-on:click="userPro" :disabled="isDisable">領取優惠</button>
    </div>
    <br />
    <footer><a href="https://www.eilis-ai.com/">系統提供 by EILIS智慧互動助理</a></footer>
  </div>
</template>

<script>
import Vuex from 'vuex'
import { mapActions,mapGetters,mapState } from 'vuex'
export default {
  name: 'beauty',
  methods: {
      userPro: function() {
        this.$store.dispatch('getApi', 
        {
          keyword: this.keyword,
          c: this.channelId
        })
        // 防止重複點擊按鈕
        this.isDisable = true
        setTimeout(() => {
          this.isDisable = false
        }, 2000)
    }
      
  },
  computed: {
    ...mapGetters({
      keyword: 'keyword'
    }),
    ...mapGetters({
      channelId: 'channelId'
    })
  },
  mounted() {
    document.body.style.backgroundColor="#0A0201"
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  /*background-color: #0A0201;*/
  text-align: center;
  font-family: "微軟正黑體";
}
#logo {
  background-color: white;
  border-radius: 50%;
  width: 38%;
  /*vertical-align : middle;*/
}
#closewindowbutton {
  z-index: 99999;
  color: white;
  background-color: #0A0201;
  font-weight: bolder;
  font-family: "微軟正黑體";
  width: 70%;
  margin-top: 15px;
  margin-bottom: 8px;
  padding: 8px 10px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 20px;
  border: 3px white solid;
  border-radius: 6px;
}
#closewindowbutton:hover {
  background-color: white;
  color: #982034;
}
footer {
  bottom: 2px;
  width: 100%;
  color: white;
  font-size: 13px;
  text-align: center;
  padding-bottom: 5px;
}
a {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/beauty.vue